export const ICON_BASE_URL = '//dxcqr918aoy1x.cloudfront.net/prod/public/images/core/icons/markers'

export const TOP_CITIES = {
  cities1: [
    { url: '/us/new-york-city-ny/', name: 'New York, NY' },
    { url: '/gb/london-eng/', name: 'London, England' },
    { url: '/us/chicago-il/', name: 'Chicago, IL' },
    { url: '/au/north-sydney-new-south-wales/', name: 'Sydney, Australia' },
    { url: '/us/san-francisco-ca/', name: 'San Francisco, CA' },
    { url: '/au/east-melbourne-victoria/', name: 'Melbourne, Australia' },
    { url: '/us/washington-d-c-dc/', name: 'Washington, DC' },
    { url: '/us/los-angeles-ca/', name: 'Los Angeles, CA' },
  ],
  cities2: [
    { url: '/nz/auckland-auckland/', name: 'Auckland, New Zealand' },
    { url: '/ie/dublin-l/', name: 'Dublin, Ireland' },
    { url: '/us/louisville-ky/', name: 'Louisville, KY' },
    { url: '/ca/toronto-ontario/', name: 'Toronto, Canada' },
    { url: '/us/austin-tx/', name: 'Austin, TX' },
    { url: '/us/boston-ma/', name: 'Boston, MA' },
    { url: '/us/denver-co/', name: 'Denver, CO' },
    { url: '/us/houston-tx/', name: 'Houston, TX' },
  ],
  cities3: [
    { url: '/us/minneapolis-mn/', name: 'Minneapolis, MN' },
    { url: '/us/san-diego-ca', name: 'San Diego, CA' },
    { url: '/us/seattle-wa/', name: 'Seattle, WA' },
    { url: '/au/brisbane-queensland/', name: 'Brisbane, Australia' },
    { url: '/us/dallas-tx/', name: 'Dallas, TX' },
    { url: '/us/portland-or/', name: 'Portland, OR' },
    { url: '/us/atlanta-ga/', name: 'Atlanta, GA' },
    { url: '/us/', name: 'United States, USA' },
  ],
}

export const ACTIVITY_TYPES = [
  {
    label: 'Run',
    value: '16',
  },
  {
    label: 'Bike Ride',
    value: '11',
  },
  {
    label: 'Walk',
    value: '9',
  },
  {
    label: 'Commute',
    value: '637',
  },
  {
    label: 'Dog Walk',
    value: '204',
  },
  {
    label: 'Hike',
    value: '24',
  },
  {
    label: 'Horseback Riding',
    value: '137',
  },
  {
    label: 'Kayak',
    value: '57',
  },
  {
    label: 'Mountain Biking',
    value: '41',
  },
  {
    label: 'Other',
    value: '21',
  },
  {
    label: 'Skate',
    value: '169',
  },
  {
    label: 'Sport / Other Activity',
    value: '21',
  },
  {
    label: 'Swim',
    value: '15',
  },
  {
    label: 'Winter Sport / Activity',
    value: '10',
  },
]

export const DISTANCE_TYPE_AT_LEAST = 'atleast'
export const DISTANCE_TYPE_BETWEEN = 'between'

export const DISTANCE_TYPES = [
  {
    label: 'At least',
    value: DISTANCE_TYPE_AT_LEAST,
  },
  {
    label: 'Between',
    value: DISTANCE_TYPE_BETWEEN,
  },
]

export const UNITS = [
  {
    label: 'mi',
    value: 'mi',
  },
  {
    label: 'km',
    value: 'km',
  },
]

export const SEARCH_RADIUS = [
  {
    label: 'Neighborhood',
    value: '1000',
  },
  {
    label: 'City',
    value: '50000',
  },
]
